import { render } from "./AddRecipe.vue?vue&type=template&id=ac820bc6"
import script from "./AddRecipe.vue?vue&type=script&lang=js"
export * from "./AddRecipe.vue?vue&type=script&lang=js"

import "./AddRecipe.vue?vue&type=style&index=0&id=ac820bc6&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__